<div class="workshop-nav">
  <ul>
    <li *ngFor="let room of activeWorkshop.rooms" (click)="changeRoom(room.id)">
<!--      <img [src]="room.image | safe " [alt]="room.name">-->
      <h2>{{ room.name }}</h2>
    </li>
  </ul>
</div>
<div id="meet">
<mat-spinner *ngIf="isLoading"></mat-spinner>
</div>
